export function show_global_search(state) {
	return state.show_global_search
}

export function is_tag(state) {
	return state.is_tag
}
